import * as ActionTypes from "../Types/ActionTypes";

export const ProjectApfReport = (
  state = {
    isLoading: true,
    errMess: null,
    projectApfReport: [],
    projectApfReportId: {},
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_PROJECTAPFREPORT:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        projectApfReport: action.payload,
      };
    case ActionTypes.FETCH_PROJECTAPFREPORTID:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        projectApfReportId: action.payload,
      };

    case ActionTypes.PROJECTAPFREPORT_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        projectApfReport: [],
        projectApfReportId: [],
      };

    case ActionTypes.PROJECTAPFREPORT_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        projectApfReport: [],
        projectApfReportId: [],
      };

    default:
      return state;
  }
};
